import { render, staticRenderFns } from "./LoyaltyTransactionStat.vue?vue&type=template&id=1792390c&scoped=true"
import script from "./LoyaltyTransactionStat.vue?vue&type=script&lang=js"
export * from "./LoyaltyTransactionStat.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyTransactionStat.vue?vue&type=style&index=0&id=1792390c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1792390c",
  null
  
)

export default component.exports